export const BASE_PRUEBAS = process.env.VUE_APP_PRUEBA_ENV || '/';
export const SITEKEY_GOOGLE = process.env.VUE_APP_SITEKEY_GOOGLE;
export const GTM_CODE = process.env.VUE_APP_GTM_CODE;
export const NODE_ENV = process.env.NODE_ENV;
